import { defer, LoaderFunction } from 'react-router-dom'

import ContentPackage from '@models/ContentPackage'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

export type PrivateBooksResponse = { books: ContentPackage[] }

export type MyBooksLoaderResponse = {
  privateBooks: Promise<PrivateBooksResponse>
}

const myBooksLoader: LoaderFunction = async () => {
  const privateBooks = http.loader.post(ApiRoutes.members.privateBooksPath())

  return defer({ privateBooks })
}

export default myBooksLoader
